export const getXapValue = val => ({
  url: '/kjarni/api/v2/XapValues',
  method: 'GET',
  params: {
    $filter: `XapValueName eq '${val}'`,
  },
});

export const getWorkingHours = detailId => ({
  url: '/kjarni/api/v2/EmployeeDetailWorkingHours',
  method: 'GET',
  params: {
    $filter: `EmployeeDetailID eq ${detailId}`,
  },
});

export const getEmployeeDetailOrg = masterId => ({
  url: '/api/QDataWebModel/EmployeeDetailOrg',
  method: 'GET',
  params: {
    $filter: `Entity/EmployeeDetailID ge ${masterId}1 and Entity/EmployeeDetailID le ${masterId}9 and (Entity/EmployeeStatus eq '0' or (Entity/EmployeeStatus ge '4'  and Entity/EmployeeStatus le '7')) and Entity/Begda le datetime'${new Date().toISOString()}' and Entity/Endda ge datetime'${new Date().toISOString()}'`,
  },
});

export const getInOutEntries = (dateFrom, dateTo, unitId, cancelToken) => ({
  url: '/kjarni/api/v2/ClockCardEntries/ByPeriodAndUnitId',
  method: 'POST',
  data: {
    unitIds: unitId,
    dateFrom,
    dateTo,
  },
  cancelToken,
});

export const getOrgCompanyUnits = () => ({
  url: '/kjarni/api/v2/OrgCompanyUnits',
  method: 'GET',
});



// WEBPACK FOOTER //
// ./src/sites/inOut/api.js